import { getChainNameById } from '@shared/helpers/web3/chain';
import type { TokenInfo } from '@shared/helpers/web3/erc20';

import type { RewardPoolDistributionSettings } from '@api/types/rewardPools';

export const getTokenNameTitle = (
  { swap_token, swap_chain }: RewardPoolDistributionSettings,
  tokenInfo?: TokenInfo,
): string => {
  if (!swap_token || !swap_chain) {
    return 'Any Token';
  }

  if (!tokenInfo) {
    return 'Unknown';
  }

  return `${tokenInfo.symbol} on ${getChainNameById(swap_chain)} Chain`;
};
